var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"QRCode",style:({'width':_vm.width, 'height':_vm.height})},[_c('canvas',{style:({'width':_vm.width, 'height':_vm.height}),attrs:{"id":_vm.canvasId}}),_vm._v(" "),(_vm.load || _vm.view)?_c('div',{staticClass:"QQMode"},[(_vm.load)?_c('i',{attrs:{"type":"el-icon-download"},on:{"click":_vm.loadCode}}):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-557a7f3b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/QRcode/index.vue
// module id = null
// module chunks = 